import { render, staticRenderFns } from "./InstrumentsTable.vue?vue&type=template&id=77d05f87&scoped=true"
import script from "./InstrumentsTable.vue?vue&type=script&lang=ts"
export * from "./InstrumentsTable.vue?vue&type=script&lang=ts"
import style0 from "./InstrumentsTable.vue?vue&type=style&index=0&id=77d05f87&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77d05f87",
  null
  
)

export default component.exports